"use client";

import {
	Accordion,
	Bone,
	Heading,
	Skeleton
} from "@pamperedchef/design-system";
import * as styles from "./stubs.module.scss";

const FACET_GROUPS = [
	"New This Month",
	"Collection",
	"Item Type",
	"Best Sellers",
	"Material",
	"Price",
	"Rating"
];

export interface PlpFacetRailProps {
	/** Facet-group labels to render as placeholder accordion sections. */
	groups?: string[];
}

/** STUB product-filters rail — a DS `Accordion` with skeleton option lists. */
export function PlpFacetRail({
	groups = FACET_GROUPS
}: PlpFacetRailProps): JSX.Element {
	const sections = groups.map((title) => ({
		title,
		content: (
			<Skeleton>
				<Bone times={4} height="14px" width="70%" borderRadius="4px" />
			</Skeleton>
		)
	}));

	return (
		<section className={styles["stackSm"]} data-component="PlpFacetRail">
			<Heading
				tag="h2"
				textContent={`Product Filters (${groups.length})`}
			/>
			<Accordion sections={sections} initialOpen={[]} />
		</section>
	);
}
